export default {
  
  en: {
    marketingSMSTemplates: 'Marketing SMS Templates',
    templateID: 'Template ID',
    templateName: 'Template name',
    type: 'Type',
    templateContent: 'Template content',
    updateTime: 'Update time',
    operate: 'Operate',
    edit: 'Edit',
    templateType: 'Template Type',
    templateRemarks: 'Template Remarks',
    taskName: 'Task name',
    modifyTemplate: 'Modify template',
    state: 'State',
    crowds: 'Crowds',
    addTemplate: 'Add Template',
    SMSDeliveryTasks: 'SMS Delivery Tasks',
    taskNode: 'Task node',
    addTask: 'Add Task',
    sendingMethod: 'Sending method',
    sendingTime: 'Sending time',
    SMS: 'SMS',
    voice: 'voice',
    fireBase: 'fireBasePush',
    whatsapp: 'whatsapp',
    ycloud: 'ycloud',
    typeOfCoupon: 'coupon',
    everyDay: 'Every Day',
    setTime: 'Set Time',

    sendingTripartition: 'Sending tripartition',
    product: 'Product',
    modifyTasks: 'Modify tasks',
    taskStatus: 'Task status',
    typeOfSMS: 'Type of SMS',
    SMSTemplates: 'SMS Templates',
    targetSendingAudience: 'Target sending audience',
    all: 'all',
    open: 'Open',
    close: 'Close',
    amountRaisingCoupon: 'Amount-raising coupon',
    coupon: 'Coupon',
    telemarketPreCoupon: 'Telemarketing coupons',
    couponID: 'Coupon ID',
    couponName: 'Coupon Name',
    couponStatus: 'Coupon Status',
    numberOfCoupons: 'Number of coupons',
    numberOfRemainingCoupons: 'Number of remaining coupons ',
    couponAmount: 'Coupon Amount',
    couponRestrictions: 'Coupon Restrictions',
    couponType: 'Coupon Type',
    couponDescription: 'Coupon Description',
    couponEffectiveDate: 'Coupon Effective Date',
    numberOfDaysInEffectForUsers: 'Number of days in effect for users',
    addCoupon: 'add coupon',
    modifyCoupon: 'Modify coupon',
    manageCouponTask: 'Manage Coupon Task',
    node: 'Node',
    search: 'Search',
    reset: 'Reset',
    success: 'success',
    sendType: 'sending type',
    oaJexlId: 'Algorithmid',
    taskDesc: 'Task Distribution',
    loanDesc: 'Loan Disbursement',
    loanNoLimitDesc: 'Task Distribution(No Limit)',
  },
  es:{
    marketingSMSTemplates: 'Plantillas de SMS de marketing',
    templateID: 'ID de la plantilla',
    templateName: 'Nombre de la plantilla',
    type: 'Tipo',
    templateContent: 'Contenido de la plantilla',
    updateTime: 'tiempo de actualización',
    operate: 'Operar',
    edit: 'Editar',
    templateType: 'Tipo de la plantilla',
    templateRemarks: 'Plantilla Observaciones',
    taskName: 'Nombre de la tarea',
    modifyTemplate: 'Modificar plantilla',
    state: 'Estado',
    crowds: 'Grupo',
    addTemplate: 'Añadir plantilla',
    SMSDeliveryTasks: 'Tareas de envío de SMS',
    taskNode: 'nodo de tareas',
    addTask: 'Añadir tareas',
    sendingMethod: 'método de transmisión',
    sendingTime: 'tiempo de transmisión',
    SMS: 'SMS',
    voice: 'voice',
    fireBase: 'fireBasePush',
    whatsapp: 'whatsapp',
    ycloud: 'ycloud',
    typeOfCoupon: 'cupón',
    everyDay: 'Every Day',
    setTime: 'Set Time',

    sendingTripartition: 'el tercero de enviar',
    product: 'productos',
    modifyTasks: 'Modificar la tarea',
    taskStatus: 'Estado de la tarea',
    typeOfSMS: 'Tipo de SMS',
    SMSTemplates: 'Plantillas SMS',
    targetSendingAudience: 'grupo destinatario',
    all: 'all',
    open: 'Iniciar',
    close: 'Cerrar',
    amountRaisingCoupon: 'cupón de retirada de efectivo',
    coupon: 'cupón de descuento',
    telemarketPreCoupon: 'cupón de descuento de telemarketing',
    couponID: 'ID del cupón',
    couponName: 'Nombre del cupón',
    couponStatus: 'Estado del cupón',
    numberOfCoupons: 'cantidad de cupones',
    numberOfRemainingCoupons: 'cantidad de cupones restantes',
    couponAmount: 'Monto del cupón',
    couponRestrictions: 'Restricciones del cupón',
    couponType: 'Tipo del cupón',
    couponDescription: 'Descripción del cupón',
    couponEffectiveDate: 'tiempo de inicio del cupón',
    numberOfDaysInEffectForUsers: 'días de validacion para usuarios',
    addCoupon: 'add cupón',
    modifyCoupon: 'Modificar cupón',
    manageCouponTask: 'Gestión de tareas de cupones',
    node: 'nodo',
    search: 'Buscar',
    reset: 'Reiniciar',
    success: 'success',

    sendType: 'Tipo de envío',
    oaJexlId: 'Algorithmid',
    taskDesc: 'Task Distribution',
    loanDesc: 'Loan Disbursement',
    loanNoLimitDesc: 'Task Distribution(No Limit)',
  }
}
